import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { ApiInterceptor } from './api.interceptor';
import { ApiInterceptorOptions } from './api.interceptor-options';

export const API_INTERCEPTOR = new InjectionToken<unknown>('API_INTERCEPTOR_TOKEN');

@NgModule({
  imports: [],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true
    },
    provideHttpClient(withXhr(), withInterceptorsFromDi())
  ]
})
export class ApiInterceptorModule {
  static forRoot(options: Partial<ApiInterceptorOptions>): ModuleWithProviders<ApiInterceptorModule> {
    return {
      ngModule: ApiInterceptorModule,
      providers: [
        {
          provide: API_INTERCEPTOR,
          useValue: options
        }
      ]
    };
  }
}
